/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardPostWinConfigText } from './RewardPostWinConfigText';
import {
    RewardPostWinConfigTextFromJSON,
    RewardPostWinConfigTextFromJSONTyped,
    RewardPostWinConfigTextToJSON,
} from './RewardPostWinConfigText';

/**
 * One prize's editable content. Only the name and post-win config can change once a schedule exists.
 * @export
 * @interface RewardContentUpdateRequest
 */
export interface RewardContentUpdateRequest {
    /**
     * 
     * @type {RewardPostWinConfigText}
     * @memberof RewardContentUpdateRequest
     */
    postWinConfig: RewardPostWinConfigText;
    /**
     * 
     * @type {string}
     * @memberof RewardContentUpdateRequest
     */
    rewardName: string;
    /**
     * 
     * @type {string}
     * @memberof RewardContentUpdateRequest
     */
    id: string;
}

/**
 * Check if a given object implements the RewardContentUpdateRequest interface.
 */
export function instanceOfRewardContentUpdateRequest(value: object): value is RewardContentUpdateRequest {
    if (!('postWinConfig' in value) || value['postWinConfig'] === undefined) return false;
    if (!('rewardName' in value) || value['rewardName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RewardContentUpdateRequestFromJSON(json: any): RewardContentUpdateRequest {
    return RewardContentUpdateRequestFromJSONTyped(json, false);
}

export function RewardContentUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardContentUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'postWinConfig': RewardPostWinConfigTextFromJSON(json['postWinConfig']),
        'rewardName': json['rewardName'],
        'id': json['id'],
    };
}

export function RewardContentUpdateRequestToJSON(value?: RewardContentUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'postWinConfig': RewardPostWinConfigTextToJSON(value['postWinConfig']),
        'rewardName': value['rewardName'],
        'id': value['id'],
    };
}

